export default __webpack_public_path__ + "static/media/avatar_63.c0ce3e67.png";